import React, { useState, useEffect } from 'react'
import { setLoading, setSnackInfo } from '../../../redux/actions/appAction'
import { connect } from 'react-redux'
import { useHistory } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import { Typography, Paper, Button, TextField } from '@material-ui/core';
import HttpService from '../../../services/httpService';
import Table from '@material-ui/core/Table';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import FavoriteIcon from '@material-ui/icons/Favorite';
import Box from '@material-ui/core/Box';
import '../style.css';
import backImage from '../../../assets/img/org/Pink-Blue-Texture.jpeg';
import backImage1 from '../../../assets/img/org/white-texture.webp';
const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textFieldWidth: {
        width: "100%"
    },
    executionui: {
        background: '#673ab7',
        marginTop: "20px",
        height: "100%"
    },
    pos: {
        marginBottom: 12,
    },
    container: {
        maxHeight: 450,
    },
    table: {
        minWidth: 700,
    },
    responsiveTable: {
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginLeft: '0',
            overflowX: 'auto',
        },
    },
    mobileTableCell: {
        [theme.breakpoints.down('sm')]: {
            padding: '8px 4px',
            fontSize: '0.8rem',
        },
    },
    feedbackField: {
        [theme.breakpoints.down('sm')]: {
            width: '100% !important',
        },
        [theme.breakpoints.up('md')]: {
            width: '50% !important',
        },
    },
    submitButton: {
        [theme.breakpoints.down('sm')]: {
            width: '100% !important',
        },
        [theme.breakpoints.up('md')]: {
            width: '30% !important',
        },
    }
}))

const ExecutionForm = (props) => {
    const classes = useStyles();
    const history = useHistory();

    useEffect(() => {
        if (props.LEADOWNERDATA.leadId) {
            findExistingLead(props.LEADOWNERDATA.leadId)
        }
        // eslint-disable-next-line
    }, [props.LEADOWNERDATA, props.TYPEOPTION])

    const findExistingLead = async (leadId) => {
        props.setLoading(true)
        try {
            const isExistsLead = await HttpService.findExistingCustomerSurveyLead(leadId, 'execution')
            if (isExistsLead.data.length !== 0) {
                history.push('/thank-you');
            }
        } catch (error) {
            // props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
            console.log(error)
        }
        props.setLoading(false)
    }
    const [satisfactionIndexRatioList, setSatisfactionIndexRatioList] = useState([
        { id: 1, description: 'Quality of finishing', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 2, description: 'Quality of materials', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 3, description: 'Responsiveness', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 4, description: 'Site coordination', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' },
        { id: 5, description: 'Pace of delivery', 1: '', 2: '', 3: '', 4: '', 5: '', 6: '', 7: '', 8: '', 9: '', 10: '' }
    ]);

    const [executionFormData, setExecutionFormData] = useState({
        howSatisfiedWithExecutionAndDelivery: "",
        howSatisfiedWithExecutionTeam: "",
        satisfactionIndexRatio: [],
        feedbackForSpecificVendor: "",
        additionalFeedback: "",
        experienceWithSalesTeam: "",
        experienceWithDesignTeam: "",
        feedbackWithSalesTeam: "",
        feedbackWithDesignTeam: ""
    })

    const [showNextPage, setShowNextPage] = useState(false);
    const [disabledBtn, setDisabledBtn] = useState(true);
    const satisfactionIndexRadio = (event, index, data) => {
        const newSatisfactionIndexRatioList = [...satisfactionIndexRatioList];

        newSatisfactionIndexRatioList[index].actionSelected = event.target.value;
        newSatisfactionIndexRatioList[index].sortId = data.id ? data.id : data.sortId;
        newSatisfactionIndexRatioList[index].description = data.description;
        delete newSatisfactionIndexRatioList[index]['1'];
        delete newSatisfactionIndexRatioList[index]['2'];
        delete newSatisfactionIndexRatioList[index]['3'];
        delete newSatisfactionIndexRatioList[index]['4'];
        delete newSatisfactionIndexRatioList[index]['5'];
        delete newSatisfactionIndexRatioList[index]['6'];
        delete newSatisfactionIndexRatioList[index]['7'];
        delete newSatisfactionIndexRatioList[index]['8'];
        delete newSatisfactionIndexRatioList[index]['9'];
        delete newSatisfactionIndexRatioList[index]['10'];

        setExecutionFormData({ ...executionFormData, satisfactionIndexRatio: newSatisfactionIndexRatioList })
        let countCheck = 0;
        newSatisfactionIndexRatioList.forEach((ele, i) => {
            if (ele.hasOwnProperty('actionSelected')) {
                countCheck++
            }
        })
        if (newSatisfactionIndexRatioList.length === countCheck) {
            setDisabledBtn(false);
        } else {
            setDisabledBtn(true)
        }
    }

    const submitExecutionForm = async () => {
        let obj = {
            ...executionFormData,
            leadOwner: props.LEADOWNERDATA,
            typeOption: props.TYPEOPTION
        }
        props.setLoading(true)
        try {
            await HttpService.submitSurveyForm(obj)
            history.push('/thank-you');
        } catch (error) {
            props.setSnackInfo(error?.response?.data?.message ?? "Something went wrong", "error")
        }
        props.setLoading(false)
    }

    return (
        <div>
            <Paper className={classes.executionui}>
                <Typography variant="h6" gutterBottom style={{ marginLeft: 10, paddingTop: 20, fontSize: 27, fontWeight: 700, color: "white" }}>
                    Customer Satisfaction Survey - Execution Process
                </Typography>
                <Typography variant='subtitle2' gutterBottom style={{ marginLeft: 10, fontWeight: 550, color: "white" }}>
                    CRM -{'>'} Design expert -{'>'} Designer -{'>'} <span className="step1" style={{ color: '#fff' }}>Operations & Production -{'>'} Site Execution -{'>'} Beautiful home delivered.</span>
                </Typography>
                <Typography variant='subtitle2' gutterBottom style={{ marginLeft: 10, fontWeight: 550, color: "white" }}>
                    Thank you for choosing Decorpot. It is our great pleasure to provide you the best quality of service at all stages.
                </Typography>
                <Typography variant='subtitle2' gutterBottom style={{ marginLeft: 10, marginTop: 15, fontWeight: 550, color: "white" }}>
                    Your assistance in completing this form is greatly appreciated. Your valuable feedback will help us to serve you better and enable us to work on improving our service standards.
                </Typography>
                <Typography variant='subtitle2' gutterBottom style={{ marginLeft: 10, marginTop: 15, paddingBottom: 20, fontWeight: 550, color: "white" }}>
                    Thank you.
                </Typography>
            </Paper>

            <Paper style={{ marginTop: 20, padding: 10, borderTop: "8px solid #673ab7", borderBottom: "8px solid rgb(93, 65, 173)" }}>

                <FormControl component="fieldset" style={{ marginBottom: 20, marginTop: 20 }}>
                    <FormLabel component="legend" style={{ color: "#000" }}>How satisfied are you with the execution and delivery process? *</FormLabel>
                    <RadioGroup row aria-label="position" name="howSatisfiedWithExecutionAndDelivery" defaultValue="top"
                        value={executionFormData.howSatisfiedWithExecutionAndDelivery}
                        onChange={(e) => setExecutionFormData({ ...executionFormData, [e.target.name]: e.target.value })}
                    >
                        <FormLabel style={{ marginTop: 30, marginRight: 20, fontWeight: 500, color: "#000" }}>Not satisfied</FormLabel>
                        <FormControlLabel
                            value="1"
                            control={<Radio color="primary" />}
                            label="1"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="2"
                            control={<Radio color="primary" />}
                            label="2"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="3"
                            control={<Radio color="primary" />}
                            label="3"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="4"
                            control={<Radio color="primary" />}
                            label="4"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="5"
                            control={<Radio color="primary" />}
                            label="5"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormLabel style={{ marginTop: 30, fontWeight: 500, color: "#000" }}>Very satisfied</FormLabel>
                    </RadioGroup>
                </FormControl>

                <br />
                <FormControl component="fieldset" style={{ marginBottom: 20, marginTop: 20 }}>
                    <FormLabel component="legend" style={{ color: "#000" }}>How satisfied are you in your interactions with the Execution team? *</FormLabel>
                    <RadioGroup row aria-label="position" name="howSatisfiedWithExecutionTeam" defaultValue="top"
                        value={executionFormData.howSatisfiedWithExecutionTeam}
                        onChange={(e) => setExecutionFormData({ ...executionFormData, [e.target.name]: e.target.value })}
                    >
                        <FormLabel style={{ marginTop: 30, marginRight: 20, fontWeight: 500, color: "#000" }}>Not satisfied</FormLabel>
                        <FormControlLabel
                            value="1"
                            control={<Radio color="primary" />}
                            label="1"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="2"
                            control={<Radio color="primary" />}
                            label="2"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="3"
                            control={<Radio color="primary" />}
                            label="3"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="4"
                            control={<Radio color="primary" />}
                            label="4"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="5"
                            control={<Radio color="primary" />}
                            label="5"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormLabel style={{ marginTop: 30, fontWeight: 500, color: "#000" }}>Very satisfied</FormLabel>
                    </RadioGroup>
                </FormControl>
                <br />
                <FormControl component="fieldset" style={{ marginBottom: 50, marginTop: 50 }}>
                    <FormLabel component="legend" style={{ color: "#000" }}>Satisfaction index -</FormLabel>
                    <FormLabel component="legend" style={{ color: "#000", marginTop: "30px" }}>
                        <span className='satisfiedDetail'></span>
                        <span style={{ marginLeft: "10px", marginTop: "70px" }}>Dissatisfied</span>
                        <span className='DissatisfiedDetail'></span>
                        <span style={{ marginLeft: "10px", marginTop: "70px" }}>Satisfied</span>
                    </FormLabel>
                </FormControl>

                {/* Desktop Table View */}
                <div className='executionDesktop'>
                    <TableContainer className={classes.responsiveTable}>
                        <Table striped  className={classes.table} aria-label="satisfaction index table">
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan={10} style={{ fontWeight: 500, width: "20rem" }}></TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 700, width: "3rem", backgroundColor: "#e72600" }}>
                                        <span style={{ color: "#fff" }}>1</span>
                                    </TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 700, width: "3rem", backgroundColor: "#f96500" }}>
                                        <span style={{ color: "#fff" }}>2</span>
                                    </TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 700, width: "3rem", backgroundColor: "#ffe000" }}>
                                        <span style={{ color: "#fff" }}>3</span>
                                    </TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 700, width: "3rem", backgroundColor: "#30ad00" }}>
                                        <span style={{ color: "#fff" }}>4</span>
                                    </TableCell>
                                    <TableCell style={{ textAlign: 'center', fontWeight: 700, width: "3rem", backgroundColor: "#218b00" }}>
                                        <span style={{ color: "#fff" }}>5</span>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {satisfactionIndexRatioList.map((row, i) => (
                                    <TableRow key={`row-${i}`}>
                                        <TableCell colSpan={10} style={{ fontWeight: 500, width: "20rem", border: '1px solid lightgray' }}>
                                            {row.description}
                                        </TableCell>
                                        <TableCell style={{ textAlign: 'center', width: "3rem", border: '1px solid lightgray' }}>
                                            <Radio
                                                value='1'
                                                checked={row.actionSelected === '1'}
                                                onChange={(e) => satisfactionIndexRadio(e, i, row)}
                                                style={{
                                                    backgroundColor: row.actionSelected === '1' ? '#fde6f0' : '',
                                                    borderRadius: row.actionSelected === '1' ? '0px' : ''
                                                }}
                                                name={`rating-${i}-1`}
                                            />
                                        </TableCell>
                                        <TableCell style={{ textAlign: 'center', width: "3rem", border: '1px solid lightgray' }}>
                                            <Radio
                                                value='2'
                                                checked={row.actionSelected === '2'}
                                                onChange={(e) => satisfactionIndexRadio(e, i, row)}
                                                style={{
                                                    backgroundColor: row.actionSelected === '2' ? '#fde6f0' : '',
                                                    borderRadius: row.actionSelected === '2' ? '0px' : ''
                                                }}
                                                name={`rating-${i}-2`}
                                            />
                                        </TableCell>
                                        <TableCell style={{ textAlign: 'center', width: "3rem", border: '1px solid lightgray', }}>
                                            <Radio
                                                value='3'
                                                checked={row.actionSelected === '3'}
                                                onChange={(e) => satisfactionIndexRadio(e, i, row)}
                                                style={{
                                                    backgroundColor: row.actionSelected === '3' ? '#fde6f0' : '',
                                                    borderRadius: row.actionSelected === '3' ? '0px' : ''
                                                }}
                                                name={`rating-${i}-3`}
                                            />
                                        </TableCell>
                                        <TableCell style={{ textAlign: 'center', width: "3rem", border: '1px solid lightgray', }}>
                                            <Radio
                                                value='4'
                                                checked={row.actionSelected === '4'}
                                                onChange={(e) => satisfactionIndexRadio(e, i, row)}
                                                style={{
                                                    backgroundColor: row.actionSelected === '4' ? '#fde6f0' : '',
                                                    borderRadius: row.actionSelected === '4' ? '0px' : ''
                                                }}
                                                name={`rating-${i}-4`}
                                            />
                                        </TableCell>
                                        <TableCell style={{ textAlign: 'center', width: "3rem", border: '1px solid lightgray', }}>
                                            <Radio
                                                value='5'
                                                checked={row.actionSelected === '5'}
                                                onChange={(e) => satisfactionIndexRadio(e, i, row)}
                                                style={{
                                                    backgroundColor: row.actionSelected === '5' ? '#fde6f0' : '',
                                                    borderRadius: row.actionSelected === '5' ? '0px' : ''
                                                }}
                                                name={`rating-${i}-5`}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                                <TableRow>
                                    <TableCell colSpan={10}></TableCell>
                                    <TableCell style={{ textAlign: 'center', border: '1px solid lightgray', }}>
                                        <ThumbDownIcon style={{ color: "#e72600" }} />
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell style={{ textAlign: 'center', border: '1px solid lightgray', }}>
                                        <ThumbUpIcon style={{ color: "#218b00" }} />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>

                {/* Mobile Table View */}
                <div className='executionPhone'>
                    <TableContainer className={classes.responsiveTable}>
                        <Table aria-label="mobile satisfaction index table">
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ fontWeight: 500, minWidth: "120px" , border: '1px solid lightgray',}}>Criteria</TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: "#e72600", padding: '4px', minWidth: '40px', border: '1px solid lightgray', }}>
                                        <span style={{ color: "#fff" }}>1</span>
                                    </TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: "#f96500", padding: '4px', minWidth: '40px', border: '1px solid lightgray', }}>
                                        <span style={{ color: "#fff" }}>2</span>
                                    </TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: "#ffe000", padding: '4px', minWidth: '40px', border: '1px solid lightgray', }}>
                                        <span style={{ color: "#fff" }}>3</span>
                                    </TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: "#30ad00", padding: '4px', minWidth: '40px', border: '1px solid lightgray', }}>
                                        <span style={{ color: "#fff" }}>4</span>
                                    </TableCell>
                                    <TableCell style={{ textAlign: 'center', backgroundColor: "#218b00", padding: '4px', minWidth: '40px', border: '1px solid lightgray', }}>
                                        <span style={{ color: "#fff" }}>5</span>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {satisfactionIndexRatioList.map((row, i) => (
                                    <TableRow key={`mobile-row-${i}`}>
                                        <TableCell className={classes.mobileTableCell} style={{ fontWeight: 500 }}>
                                            {row.description}
                                        </TableCell>
                                        <TableCell className={classes.mobileTableCell} style={{ textAlign: 'center', padding: '2px', border: '1px solid lightgray', }}>
                                            <Radio
                                                value='1'
                                                checked={row.actionSelected === '1'}
                                                onChange={(e) => satisfactionIndexRadio(e, i, row)}
                                                style={{
                                                    backgroundColor: row.actionSelected === '1' ? '#fde6f0' : '',
                                                    padding: '4px'
                                                }}
                                                size="small"
                                                name={`mobile-rating-${i}-1`}
                                            />
                                        </TableCell>
                                        <TableCell className={classes.mobileTableCell} style={{ textAlign: 'center', padding: '2px', border: '1px solid lightgray', }}>
                                            <Radio
                                                value='2'
                                                checked={row.actionSelected === '2'}
                                                onChange={(e) => satisfactionIndexRadio(e, i, row)}
                                                style={{
                                                    backgroundColor: row.actionSelected === '2' ? '#fde6f0' : '',
                                                    padding: '4px'
                                                }}
                                                size="small"
                                                name={`mobile-rating-${i}-2`}
                                            />
                                        </TableCell>
                                        <TableCell className={classes.mobileTableCell} style={{ textAlign: 'center', padding: '2px', border: '1px solid lightgray', }}>
                                            <Radio
                                                value='3'
                                                checked={row.actionSelected === '3'}
                                                onChange={(e) => satisfactionIndexRadio(e, i, row)}
                                                style={{
                                                    backgroundColor: row.actionSelected === '3' ? '#fde6f0' : '',
                                                    padding: '4px'
                                                }}
                                                size="small"
                                                name={`mobile-rating-${i}-3`}
                                            />
                                        </TableCell>
                                        <TableCell className={classes.mobileTableCell} style={{ textAlign: 'center', padding: '2px', border: '1px solid lightgray', }}>
                                            <Radio
                                                value='4'
                                                checked={row.actionSelected === '4'}
                                                onChange={(e) => satisfactionIndexRadio(e, i, row)}
                                                style={{
                                                    backgroundColor: row.actionSelected === '4' ? '#fde6f0' : '',
                                                    padding: '4px'
                                                }}
                                                size="small"
                                                name={`mobile-rating-${i}-4`}
                                            />
                                        </TableCell>
                                        <TableCell className={classes.mobileTableCell} style={{ textAlign: 'center', padding: '2px', border: '1px solid lightgray', }}>
                                            <Radio
                                                value='5'
                                                checked={row.actionSelected === '5'}
                                                onChange={(e) => satisfactionIndexRadio(e, i, row)}
                                                style={{
                                                    backgroundColor: row.actionSelected === '5' ? '#fde6f0' : '',
                                                    padding: '4px'
                                                }}
                                                size="small"
                                                name={`mobile-rating-${i}-5`}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                                <TableRow>
                                    <TableCell className={classes.mobileTableCell}></TableCell>
                                    <TableCell className={classes.mobileTableCell} style={{ textAlign: 'center', border: '1px solid lightgray', }}>
                                        <ThumbDownIcon style={{ color: "#e72600", fontSize: '1rem' }} />
                                    </TableCell>
                                    <TableCell className={classes.mobileTableCell}></TableCell>
                                    <TableCell className={classes.mobileTableCell}></TableCell>
                                    <TableCell className={classes.mobileTableCell}></TableCell>
                                    <TableCell className={classes.mobileTableCell} style={{ textAlign: 'center', border: '1px solid lightgray', }}>
                                        <ThumbUpIcon style={{ color: "#218b00", fontSize: '1rem' }} />
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <br />

                <TextField
                    label="Feedback on specific vendor *"
                    size="small"
                    className={classes.feedbackField}
                    style={{ marginBottom: 20, textAlign: "center", marginTop: 20, backgroundColor: "#f0ebf8" }}
                    name="feedbackForSpecificVendor"
                    multiline
                    rows={3}
                    onChange={(e) => setExecutionFormData({ ...executionFormData, [e.target.name]: e.target.value })}
                    variant="outlined"
                />

                <br />
                <TextField
                    label="Additional comments *"
                    size="small"
                    style={{ marginBottom: 20, textAlign: "center", marginTop: 20, width: "100%", backgroundColor: "#f8f1fb" }}
                    name="additionalFeedback"
                    multiline
                    rows={3}
                    onChange={(e) => setExecutionFormData({ ...executionFormData, [e.target.name]: e.target.value })}
                    variant="outlined"
                />
                <br />

                {/*Feedback section for sales and design */}
                <FormControl component="fieldset" style={{ marginBottom: 20, marginTop: 20 }}>
                    <FormLabel component="legend" style={{ color: "#000" }}>How was your experience with the sales team? *</FormLabel>
                    <RadioGroup row aria-label="position" name="experienceWithSalesTeam" defaultValue="top"
                        value={executionFormData.experienceWithSalesTeam}
                        onChange={(e) => setExecutionFormData({ ...executionFormData, [e.target.name]: e.target.value })}
                    >
                        <FormLabel style={{ marginTop: 30, marginRight: 20, fontWeight: 500, color: "#000" }}>Not satisfied</FormLabel>
                        <FormControlLabel
                            value="1"
                            control={<Radio color="primary" />}
                            label="1"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="2"
                            control={<Radio color="primary" />}
                            label="2"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="3"
                            control={<Radio color="primary" />}
                            label="3"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="4"
                            control={<Radio color="primary" />}
                            label="4"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="5"
                            control={<Radio color="primary" />}
                            label="5"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormLabel style={{ marginTop: 30, fontWeight: 500, color: "#000" }}>Very satisfied</FormLabel>
                    </RadioGroup>
                    <TextField
                        label="Feedback for sales team *"
                        size="small"
                        style={{ marginBottom: 10, textAlign: "center", marginTop: 20, width: "80%", backgroundColor: "#f0ebf8" }}
                        name="feedbackWithSalesTeam"
                        multiline
                        rows={2}
                        onChange={(e) => setExecutionFormData({ ...executionFormData, [e.target.name]: e.target.value })}
                        variant="outlined"
                    />
                </FormControl>
                <br />

                <FormControl component="fieldset" style={{ marginBottom: 20, marginTop: 20 }}>
                    <FormLabel component="legend" style={{ color: "#000" }}>How was your experience with the design team? *</FormLabel>
                    <RadioGroup row aria-label="position" name="experienceWithDesignTeam" defaultValue="top"
                        value={executionFormData.experienceWithDesignTeam}
                        onChange={(e) => setExecutionFormData({ ...executionFormData, [e.target.name]: e.target.value })}
                    >
                        <FormLabel style={{ marginTop: 30, marginRight: 20, fontWeight: 500, color: "#000" }}>Not satisfied</FormLabel>
                        <FormControlLabel
                            value="1"
                            control={<Radio color="primary" />}
                            label="1"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="2"
                            control={<Radio color="primary" />}
                            label="2"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="3"
                            control={<Radio color="primary" />}
                            label="3"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="4"
                            control={<Radio color="primary" />}
                            label="4"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormControlLabel
                            value="5"
                            control={<Radio color="primary" />}
                            label="5"
                            labelPlacement="top"
                            style={{ marginLeft: 0 }}
                        />
                        <FormLabel style={{ marginTop: 30, fontWeight: 500, color: "#000" }}>Very satisfied</FormLabel>
                    </RadioGroup>

                    <TextField
                    label="Feedback for design team *"
                    size="small"
                    style={{ marginBottom: 10, textAlign: "center", marginTop: 20, width: "80%", backgroundColor: "#f0ebf8" }}
                    name="feedbackWithDesignTeam"
                    multiline
                    rows={2}
                    onChange={(e) => setExecutionFormData({ ...executionFormData, [e.target.name]: e.target.value })}
                    variant="outlined"
                />
                </FormControl>
                
            </Paper>
            <Paper style={{ marginTop: 20, padding: 10 }}>
                <Button onClick={submitExecutionForm} variant="contained" color="primary" style={{ width: "30%" }}
                    disabled={executionFormData.howSatisfiedWithExecutionAndDelivery === '' || executionFormData.howSatisfiedWithExecutionTeam === '' || executionFormData.feedbackForSpecificVendor === '' || executionFormData.additionalFeedback === '' || disabledBtn || !executionFormData.experienceWithSalesTeam ||!executionFormData.experienceWithDesignTeam ||!executionFormData.feedbackWithSalesTeam ||!executionFormData.feedbackWithDesignTeam}
                >
                    Submit
                </Button>
            </Paper>
        </div>
    )
}

export default connect(null, { setLoading, setSnackInfo })(ExecutionForm)
